// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/cob-storyblok/" + {"8213":"cob-storyblok.show-highlight-product-plugin.plugin","62232":"cob-storyblok.close-highlight-product-plugin.plugin"}[chunkId] + "." + {"8213":"c8425d","62232":"358175"}[chunkId] + ".js";
};